/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { INurse } from 'app/shared/model/nurse.model';
import { IShift } from 'app/shared/model/shift.model';
import { IDepartment } from 'app/shared/model/department.model';
import { IHospital } from 'app/shared/model/hospital.model';
import { IWard } from 'app/shared/model/ward.model';

export interface ISchedule {
  id?: string;
  scheduleDate?: number | null;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdate?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  served?: boolean | null;
  hoursServed?: number | null;
  nurse?: INurse | null;
  shift?: IShift | null;
  department?: IDepartment | null;
  hospital?: IHospital | null;
  ward?: IWard | null;
}

export const defaultValue: Readonly<ISchedule> = {
  active: false,
  served: false,
};
